import {Injectable} from '@angular/core';
import {CoreConfigService} from '@core/services/config.service';
import {environment} from '../../../environments/environment';
import {LocalStorageKeys, StorageService} from '../../global/storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthHelperService {

  constructor(private configService: CoreConfigService, private storageService: StorageService) { }


  /**
   * set layout config behalf on Auth
   * @param hidden
   * @param customizer
   * @param enableLocalStorage
   */
  setLayoutConfig(hidden: boolean, customizer: boolean, enableLocalStorage: boolean){
    this.configService.setCconfig({
      layout: {
        navbar: {
          hidden: hidden
        },
        footer: {
          hidden: hidden
        },
        menu: {
          hidden: hidden
        },
        customizer: customizer,
        enableLocalStorage: enableLocalStorage
      }
    });
  }

  getLocalDevToken(){ //TODO: temporary fix while BE will allow to connect from localhost
      return environment?.allowTokenLogins === true ? this.storageService.getItem(LocalStorageKeys.DEV_ACCESS_TOKEN) : null;
  }

}
